@if (enableScrollButtons) { @if (scrollState.hasHorizontalScrollBar &&
isHorizontal) { @if (!scrollState.scrolledToLeft) {
<div
  class="scroll horizontal left d-sm-flex d-none justify-content-center"
  (click)="this.scroll(ScrollDirection.Left)"
>
  @if (customLeftButton) {
  <ng-template [ngTemplateOutlet]="customLeftButton"></ng-template>
  } @else {
  <fa-icon [icon]="['fas', 'arrow-left']"></fa-icon>
  }
</div>
} @if (!scrollState.scrolledToRight) {
<div
  class="scroll horizontal right d-sm-flex d-none justify-content-center"
  (click)="this.scroll(ScrollDirection.Right)"
>
  @if (customRightButton) {
  <ng-template [ngTemplateOutlet]="customRightButton"></ng-template>
  } @else {
  <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
  }
</div>
} } @if (scrollState.hasVerticalScrollBar && isVertical) { @if
(!scrollState.scrolledToTop) {
<div
  class="scroll vertical top d-sm-flex d-none justify-content-center"
  (click)="this.scroll(ScrollDirection.Top)"
>
  @if (customTopButton) {
  <ng-template [ngTemplateOutlet]="customTopButton"></ng-template>
  } @else {
  <fa-icon [icon]="['fas', 'arrow-up']"></fa-icon>
  }
</div>
} @if (!scrollState.scrolledToBottom) {
<div
  class="scroll vertical bottom d-sm-flex d-none justify-content-center"
  (click)="this.scroll(ScrollDirection.Bottom)"
>
  @if (customBottomButton) {
  <ng-template [ngTemplateOutlet]="customBottomButton"></ng-template>
  } @else {
  <fa-icon [icon]="['fas', 'arrow-down']"></fa-icon>
  }
</div>
} } }
<div #contentContainer [ngClass]="{ 'd-block h-100': isVertical }">
  <ng-content></ng-content>
</div>
